import React, { useState } from 'react';
import styles from './ClaimHeader.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { Sparkles } from 'lucide-react';
import { FaChevronRight } from 'react-icons/fa';
import { X } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

const ClaimHeader = ({ dataPoints = [], sessionState = {}, companyData = {}, summary = "", copilot_summary = "" }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Ensure dataPoints is an array
  const safeDataPoints = Array.isArray(dataPoints) ? dataPoints : [];
  // console.log(safeDataPoints, 'safeDataPoints');
  // console.log(sessionState, 'sessionState');
  // console.log(companyData, 'companyData');
  // console.log(summary, 'summary');

  // Determine claimant name using dataPoints configuration
  // Priority 1: Find dataPoint with component='subheader' and format='username'
  let claimantNameDataPoint = safeDataPoints.find(
    dp => dp.component === 'subheader' && dp.format === 'username'
  );
  
  // Priority 2: If not found, find dataPoint with component='subheader' and business_key=true
  if (!claimantNameDataPoint) {
    claimantNameDataPoint = safeDataPoints.find(
      dp => dp.component === 'subheader' && dp.business_key === true
    );
  }
  
  // Extract claimant name from sessionState using the found dataPoint key
  const claimantName = claimantNameDataPoint 
    ? (sessionState[claimantNameDataPoint.key] || "Unknown")
    : (sessionState?.caseId || "Unknown");
  

  summary = summary || sessionState['ai_summary']
  // Filter dataPoints for subheader component, excluding the one used for claimantName
  const subheaderDataPoints = safeDataPoints
    .filter(dp => dp.component === 'subheader' && dp.key !== claimantNameDataPoint?.key)
    .sort((a, b) => (a.header_order || 0) - (b.header_order || 0));
    
    // Filter dataPoints for header stats (show_in_header === true)
    const headerStatsDataPoints = safeDataPoints
    .filter(dp => dp.show_in_header === true)
    .filter(dp => dp.key !== 'ai_summary' && dp.key !== 'caseId' && dp.key !== 'insuredName')
    .sort((a, b) => (a.header_order || 0) - (b.header_order || 0));
  
  // Get currency symbol from company data
  const currencySymbol = companyData.currency || 'IDR';
  
  const formatValue = (dataPoint, value) => {
    if (value === null || value === undefined) return 'N/A';
    
    switch (dataPoint.format) {
      case 'percentage':
        return `${(value * 100).toFixed(0)}%`;
      case 'currency':
        const currency = dataPoint.currency || currencySymbol;
        return `${currency} ${value.toLocaleString()}`;
      case 'text':
      case 'username':
      default:
        return value;
    }
  };
  
  // Format change indicator
  const formatChange = (changeConfig, sessionState) => {
    if (!changeConfig) return null;
    
    const changeValue = sessionState[changeConfig.key];
    const changeDirection = changeConfig.changeDirection;

    
    if (changeValue === null || changeValue === undefined) return null;
    
    let formattedValue = changeValue;
    if (changeConfig.format === 'percentage') {
      formattedValue = `${changeValue.toFixed(1)}%`;
    }
    
    const arrow = changeDirection === 'positive' ? '▲ ' : '▼ ';
    const colorClass = changeDirection === 'positive' ? styles.changePositive : styles.changeNegative;
    
    return (
      <span className={colorClass}>
        {/* {arrow} */}
        {formattedValue.toFixed(0)} %
      </span>
    );
  };

  return (
    <div className={styles.card}>
      <div className={styles.claimHeader}>
        <div className={styles.userSection}>
          <div className={styles.userAvatar}>
            {/* 👤 */}
            <FontAwesomeIcon icon={faUser} size="lg" />
          </div>
          <div className={styles.userInfo}>
            <div className={styles.titleRow}>
              <h2 className={styles.claimTitle}>{claimantName}</h2>
              {/* <a href="#" className={styles.moreDetailsLink}>
                More Details <span style={{ fontSize: '0.7rem' }}>›</span>
              </a> */}
            </div>
            <div className={styles.claimSubtitle}>
              {subheaderDataPoints.map((dp) => (
                <div key={dp.key} className={styles.subtitleItem}>
                  {dp.label} <span>{formatValue(dp, sessionState[dp.key])}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.statsContainer} data-count={headerStatsDataPoints.length}>
          {headerStatsDataPoints.map((dp) => {
            console.log(dp)
            // Determine if this stat has a change and get the direction
            const changeDirection = dp.change ? sessionState[dp.change.changeDirection] : null;
            const valueColorClass = dp.label === 'Total Audit Savings' ? styles.positive : '';
            // const valueColorClass = changeDirection === 'positive' 
            //   ? styles.changePositive 
            //   : changeDirection === 'negative' 
            //     ? styles.changeNegative 
            //     : '';
            
            return (
              <div key={dp.key} className={styles.statItem}>
                <div className={styles.statLabel}>
                  {dp.label === 'Total Audit Savings' ? 'Non-Payable amount' : dp.label}
                </div>
                <div className={`${styles.statValue} ${valueColorClass}`}>
                  {formatValue(dp, sessionState[dp.key])}
                  {dp.label === 'Total Audit Savings' && (
                    <>
                    {(() => {
                      let tmp ={
                        key: "audit_saving_percent",
                        changeDirection: "positive"
                      }
                      return (
                        <span className={styles.changeIndicator}>
                          {' '}{formatChange(tmp, sessionState)}
                        </span>
                      )
                    })()}
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className={styles.alertBanner}>
        <div className={styles.alertIcon}>
          <Sparkles size={24} fill="#667eea" color="#667eea" />
        </div>
        <div className={styles.alertContent}>
          <div className={styles.alertDescription} dangerouslySetInnerHTML={{ __html: summary && summary.length > 0 ? summary : 'Summary is being generated... <br/>Check back later' }}></div>
          
        <button className={styles.viewMoreButton} onClick={() => setIsModalOpen(true)}>
          View More Details <FaChevronRight size={12} />
        </button>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className={styles.modalOverlay} onClick={() => setIsModalOpen(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>Detailed Summary</h2>
              <button className={styles.modalCloseButton} onClick={() => setIsModalOpen(false)}>
                <X size={24} />
              </button>
            </div>
            <div className={styles.modalBody}>
              <ReactMarkdown>{copilot_summary || 'No detailed summary available.'}</ReactMarkdown>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClaimHeader;
